import React from 'react';
import { useReserveForm } from '@/components/reserve/Reserve/ReserveFormProvider';
import { ReserveFormParkingList } from '@/components/reserve/Reserve/controls/ResereFormParkingList';
import { cn } from '@gettactic/helpers';

export interface ReserveFormParkingProps {
  className?: string;
}

export const ReserveFormParking: React.FC<ReserveFormParkingProps> = ({
  className
}) => {
  const { allowParking } = useReserveForm();
  if (!allowParking) return null;

  return (
    <div className={cn('mb-5', className)}>
      <ReserveFormParkingList />
    </div>
  );
};
